export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'A chi è rivolto Pilates Reformer Pronto?',
    answer:
      'A istruttrici e istruttori di Pilates Reformer già formati che vogliono un repertorio scritto, ordinato e pronto da usare in sala, senza dover ricostruire ogni lezione da zero.',
  },
  {
    question: 'Che cosa contiene esattamente il pacchetto?',
    answer:
      'Sei volumi in PDF per un totale di 480 pagine: 120 schede esercizio illustrate, piani di lezione completi, progressioni su tre livelli e le indicazioni di regolazione del Reformer, più i cinque bonus.',
  },
  {
    question: 'In che formato ricevo i file?',
    answer:
      'PDF in formato A4 a 300 DPI, pronti per la stampa professionale e perfettamente leggibili da tablet o computer durante la lezione.',
  },
  {
    question: 'Come ricevo il materiale dopo il pagamento?',
    answer:
      'Subito. Al termine del pagamento ricevi un’email con i link di download di tutti i file: l’accesso è immediato e permanente, senza attese e senza spedizioni.',
  },
  {
    question: 'Funziona con qualsiasi modello di Reformer?',
    answer:
      'Sì. Le regolazioni sono indicate per tensione (molla leggera, media, pesante) e per posizione del carrello, quindi si adattano a tutti i principali modelli in commercio.',
  },
  {
    question: 'Posso usarlo con le mie allieve e nel mio studio?',
    answer:
      'Sì. Puoi stampare e utilizzare il materiale con tutte le tue allieve e in tutte le tue classi, anche negli anni successivi, senza limiti di utilizzo.',
  },
  {
    question: 'I nomi degli esercizi sono in inglese?',
    answer:
      'Sì, il repertorio mantiene i nomi originali in inglese — Footwork, Short Box, Long Stretch — come è consuetudine nel metodo. Tutte le spiegazioni, i benefici e le indicazioni sono in italiano.',
  },
  {
    question: 'Serve un abbonamento o è un pagamento unico?',
    answer:
      'È un pagamento unico di 19 €. Non ci sono rinnovi, canoni mensili o costi nascosti: i file restano tuoi per sempre.',
  },
  {
    question: 'Esiste una garanzia?',
    answer:
      'Sì. Hai 30 giorni per provare tutto il materiale: se non fa al caso tuo ti rimborsiamo per intero e tieni comunque i file, bonus compresi.',
  },
]
